import config from "../config";
import { getFirestore, getServerTimestamp } from "./firebase-service";

const ALLOWED_EVENTS = [
  "landing_viewed",
  "cta_clicked",
  "form_submitted",
  "lesson_completed",
];
const SAFE_IDENTIFIER = /^[A-Za-z0-9_-]+$/;

function getTrackingContext() {
  const params = new URLSearchParams(window.location.search);
  const campaignId = params.get("c") || config.tracking.campaignId;
  const participantToken = params.get("t");

  if (
    !campaignId ||
    !participantToken ||
    campaignId.length > 80 ||
    participantToken.length < 8 ||
    participantToken.length > 128 ||
    !SAFE_IDENTIFIER.test(campaignId) ||
    !SAFE_IDENTIFIER.test(participantToken)
  ) {
    return null;
  }

  return { campaignId, participantToken };
}

export function trackEvent(eventType) {
  if (!ALLOWED_EVENTS.includes(eventType)) {
    return Promise.resolve({ recorded: false, reason: "invalid-event" });
  }

  try {
    const trackingContext = getTrackingContext();
    const db = getFirestore();

    if (!trackingContext || !db) {
      return Promise.resolve({ recorded: false, reason: "not-configured" });
    }

    const event = {
      campaign_id: trackingContext.campaignId,
      participant_token: trackingContext.participantToken,
      event_type: eventType,
      occurred_at: getServerTimestamp(),
      page_path: window.location.pathname,
      client_version: config.tracking.clientVersion,
    };
    const documentId = [
      trackingContext.campaignId,
      trackingContext.participantToken,
      eventType,
    ].join("__");

    return db
      .collection(config.tracking.collection)
      .doc(documentId)
      .set(event)
      .then(() => ({ recorded: true, id: documentId }))
      .catch((error) => {
        console.error("Unable to record the simulation event.", error);
        return { recorded: false, reason: "write-failed" };
      });
  } catch (error) {
    console.error("Unable to initialize simulation event tracking.", error);
    return Promise.resolve({ recorded: false, reason: "write-failed" });
  }
}

export function trackEventWithTimeout(eventType, timeoutMs = 4000) {
  const eventPromise = trackEvent(eventType);
  let timeoutId;
  const timeout = new Promise((resolve) => {
    timeoutId = window.setTimeout(
      () => resolve({ recorded: false, reason: "timeout" }),
      timeoutMs
    );
  });

  return Promise.race([eventPromise, timeout]).then((result) => {
    if (result.reason !== "timeout") {
      window.clearTimeout(timeoutId);
    }

    return result.reason === "timeout"
      ? { ...result, pending: eventPromise }
      : result;
  });
}
